import moment, {Moment} from 'moment-timezone'

/**
 * Get the latest relevant history entry for the given date.
 * Entries should be sorted in ascending order by updatedOn or createdOn.
 */
export const getRelevantHistoryEntry = <
  T extends {updatedOn?: string; createdOn: string; id: string | number}
>(
  historyEntries: T[],
  date: Moment
): T | undefined => {
  const relevantHistoryAsc = historyEntries.filter((entry) => {
    const timeStamp = moment.utc(entry.updatedOn ?? entry.createdOn)
    return timeStamp.isBefore(date)
  })
  const relevantEntry = relevantHistoryAsc.at(-1)
  return relevantEntry
}
